import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { ListItem, Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import i18n from "i18n";
import ProfileActions from "redux-react/actions/profileActions";
import { DateTime } from "luxon";

/**
 * Right pannel list of notes contact
 * @param {*} param0
 * @returns
 */
const PannelNoteContact = ({ notesContact }) => {
	return (
		<MDBox display="flex" flex="1">
			<div style={{ borderLeft: "1px solid #ccc", height: "100%", margin: "0 10px" }} />
			<MDBox display="flex" flexDirection="column" width="100%">
				<MDBox sx={{ mb: 1 }}>
					<MDTypography variant="h6">{i18n.t("FORMS.notesOfContact")}</MDTypography>

					<MDBox mt={2}>
						{notesContact &&
							notesContact.length > 0 &&
							notesContact
								.sort((a, b) => b.ts - a.ts)
								.map((note, index) => (
									<MDBox key={"note" + index} pb={2}>
										<NoteComponent index={index} note={note} notes={notesContact} />
									</MDBox>
								))}
					</MDBox>
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

/**
 *
 * @param {*} param0
 * @returns
 */
const NoteComponent = ({ note, listOfUsers }) => {
	const user = useSelector(state => state.user);
	const profile = useSelector(state => state.profile);
	const [noteAuthorInfo, setNoteAuthorInfo] = useState({});
	const dispatch = useDispatch();

	let noteAuthor = user?.userID || user?._id;

	const getNameAgent = () => {
		let author =
			noteAuthorInfo && noteAuthorInfo?.first && noteAuthorInfo?.last
				? noteAuthorInfo.first + " " + noteAuthorInfo.last
				: noteAuthor;

		return author;
	};

	useEffect(() => {
		const onSuccess = res => {
			setNoteAuthorInfo(res.profile);
		};
		dispatch(ProfileActions.getProfileInfo(profile.assistantID, note?.author, onSuccess));
	}, []);

	return (
		note && (
			<ListItem>
				<MDBox width={1}>
					<Paper
						elevation={3}
						style={{
							backgroundColor: note?.author === noteAuthor ? "white" : "rgb(231, 231, 231)"
						}}
					>
						<MDBox p={1}>
							<MDBox display="flex" alignItems="center" justifyContent="space-between">
								<MDBox>
									{i18n.t("FORMS.noteWritter")} {getNameAgent()}
								</MDBox>
							</MDBox>

							{/***************************************************/}
							{(note?.type === "text" || note?.type === "contact") && (
								<MDBox my={1} component="div" fontWeight="fontWeightMedium" fontStyle="italic">
									<div dangerouslySetInnerHTML={{ __html: note.text }} />
								</MDBox>
							)}

							<MDBox display="flex" justifyContent="flex-end">
								<MDBox>
									{!lod_.isNil(note.ts) &&
										DateTime.fromMillis(note.ts).toFormat("dd/MM/yyyy HH:mm")}
								</MDBox>
							</MDBox>
						</MDBox>
					</Paper>
				</MDBox>
			</ListItem>
		)
	);
};

export default PannelNoteContact;
